import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import stagesReducer from './slices/stagesSlice';
import candidatesReducer from './slices/candidatesSlice';
// import jobReducer from './slices/jobsSlice';
// import authReducer from './slices/authSlice';
// import emailTemplateReducer from './slices/emailTemplateSlice';

export const store = configureStore({
    reducer: {
        stages: stagesReducer,
         candidates: candidatesReducer,
        // jobs: jobReducer,
        // auth: authReducer,
        // emailTemplates: emailTemplateReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;